import { 
    GET_LEAVE_REQUESTS,
    GET_LEAVE_REQUESTS_SUCCESS,
    GET_LEAVE_REQUESTS_FAIL,
    GET_LEAVE_REQUEST_DETAIL,
    GET_LEAVE_REQUEST_DETAIL_SUCCESS,
    GET_LEAVE_REQUEST_DETAIL_FAIL,
    ADD_LEAVE_REQUEST,
    ADD_LEAVE_REQUEST_SUCCESS,
    ADD_LEAVE_REQUEST_FAIL,
    UPDATE_LEAVE_REQUEST,
    UPDATE_LEAVE_REQUEST_SUCCESS,
    UPDATE_LEAVE_REQUEST_FAIL,
    DELETE_LEAVE_REQUEST,
    DELETE_LEAVE_REQUEST_SUCCESS,
    DELETE_LEAVE_REQUEST_FAIL,
 } from "./actionTypes"

const INIT_STATE = {
    leavePlans: [],
    leaveRequests: [],
    leavePlanDetails: {},
    leaveRequestDetails: {},
    error: {},
  }

  const leaveReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        
        case GET_LEAVE_REQUESTS_SUCCESS:
            return {
                ...state, 
                leaveRequests: action.payload 
            }
        case GET_LEAVE_REQUESTS_FAIL:
            return {
                ...state, 
                error: action.payload 
            }
        case GET_LEAVE_REQUEST_DETAIL_SUCCESS:
            return {
                ...state, 
                leaveRequestDetails: action.payload 
            }
        case GET_LEAVE_REQUEST_DETAIL_FAIL:
            return {
                ...state, 
                error: action.payload 
            }
        case ADD_LEAVE_REQUEST_SUCCESS:
            return {
                ...state,  
                leaveRequests: [...state.leaveRequests, action.payload] 
            }
        case ADD_LEAVE_REQUEST_FAIL:
            return {
                ...state, 
                error: action.payload 
            }
        case UPDATE_LEAVE_REQUEST_SUCCESS:
            return {
                ...state,
                leaveRequests: state.leaveRequests.map(request =>
                    request.id.toString() === action.payload.id.toString()
                    ? { request, ...action.payload }
                    : request
                ),
            }
        case UPDATE_LEAVE_REQUEST_FAIL:
            return {
                ...state, 
                error: action.payload, 
            }
        case DELETE_LEAVE_REQUEST_SUCCESS:
            return {
                ...state,
                leaveRequests: state.leaveRequests.filter(
                    request => request.id.toString() !== action.payload.id.toString()
                )
            }
        case DELETE_LEAVE_REQUEST_FAIL:
            return {
                ...state,
                error: action.payload
            }
        default:
            return state
    }
  }
  
  export default leaveReducer
  